import React from "react";
import { CircleCheckBigIcon, LockIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
type CtaButtonProps = {
  label: string;
  id?: string;
  note?: string;
  pulse?: boolean;
};
export function CtaButton({
  label,
  id,
  note,
  pulse = true
}: CtaButtonProps) {
  return <div className="mx-auto flex w-full max-w-xl flex-col items-center" data-id="element-44" data-mp="ck9f3o7axsdd">
      <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_10px_30px_-8px_rgba(22,163,74,0.6)] transition-[background-color,transform] duration-150 ease-out hover:bg-cta-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold sm:text-xl ${pulse ? "animate-cta-pulse" : ""}`} data-id="element-45" data-mp="qkk8axw33j1p">
        <CircleCheckBigIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-46" data-mp="15a9beynqlx4m" />
        <span data-id="element-47" data-mp="35xfm91cs6v7n">{label}</span>
      </a>
      {note && <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-sm text-navy/70" data-id="element-48" data-mp="35yqtxc9ckn41">
          <LockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-49" data-mp="39z1656nqg9rc" />
          {note}
        </p>}
    </div>;
}